if (!customElements.get('kp-slideshow')) {
  customElements.define('kp-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.kp-slide')];
      this.dots = [...this.querySelectorAll('[data-slide-index]')];
      this.index = 0;
      if (this.slides.length < 2) return;
      this.querySelectorAll('[data-slide-direction]').forEach(button => {
        button.addEventListener('click', () => this.show(this.index + Number(button.dataset.slideDirection)));
      });
      this.dots.forEach(dot => dot.addEventListener('click', () => this.show(Number(dot.dataset.slideIndex))));
      this.start = () => {
        if (this.dataset.autoplay !== 'true') return;
        if (document.hidden) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = window.setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
      };
      this.stop = () => window.clearInterval(this.timer);
      this.addEventListener('mouseenter', this.stop);
      this.addEventListener('mouseleave', this.start);
      this.addEventListener('focusin', this.stop);
      this.addEventListener('focusout', this.start);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); else this.start(); });
      this.start();
    }
    disconnectedCallback() { window.clearInterval(this.timer); }
    show(next) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.dots.forEach((dot, i) => { dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'); });
    }
  });
}
